/**
 * General utility functions
 */

// User-related helpers
export const getUserTypeLabel = (userType) => {
  switch (userType) {
    case "super_admin":
      return "Super Admin";
    case "admin":
      return "Admin";
    case "user":
      return "User";
    default:
      return userType;
  }
};

// Organization-related helpers
export const getOrganizationStatusLabel = (isActive) => {
  return isActive ? "Active" : "Inactive";
};

export const getOrganizationStatusClasses = (isActive) => {
  return isActive ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
};

// Date formatting helpers
export const formatDate = (date) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

// String helpers
export const capitalizeFirst = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

// Text alignment helper for lesson tasks
/**
 * Determines the text alignment class based on task settings and content
 * @param {string} textAlignment - The text_alignment property from the task ("none", "center", "left")
 * @param {string} textContent - The text content to analyze
 * @returns {string} - CSS class for text alignment ("text-center" or "text-left")
 */
export const getTextAlignment = (textAlignment, textContent) => {
  // If explicit alignment is set, use it
  if (textAlignment === "center") {
    return "text-center";
  }
  if (textAlignment === "left") {
    return "text-left";
  }

  // For "none" or missing alignment, use automatic logic
  if (!textContent) {
    return "text-left";
  }

  // Check for bullets/lists (markdown list indicators)
  const hasBullets =
    /^[\s]*[-*+][\s]/m.test(textContent) || // Unordered lists
    /^[\s]*\d+\.[\s]/m.test(textContent); // Ordered lists

  if (hasBullets) {
    return "text-left";
  }

  // Use word count formula
  const wordCount = textContent
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;

  return wordCount < 30 ? "text-center" : "text-left";
};
